var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCorner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "url(#paint0_linear_3564_251)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 13L12.5 20",
    stroke: "#861553",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8335 12.1253C13.8335 12.1253 19.1988 11.673 20.013 12.4872C20.8272 13.3014 20.3748 18.6667 20.3748 18.6667",
    stroke: "#a71a68",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3564_251",
    x1: -10.6549,
    y1: 10.1818,
    x2: 43.6238,
    y2: 11.5161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#861553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEEEE5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCorner);
export default __webpack_public_path__ + "static/media/ArrowCorner.225c6003bb09b18da3d11c7869270580.svg";
export { ForwardRef as ReactComponent };